import {
    setYardiDbs,
    setNeedsCreds,
    setCredsLoading,
    setSelectedDb,
    setTimeZones,
    setServerName,
    setServerLoading,
    setLockedDown,
} from "../reducers/yardidata";
import axios from "axios";
import update from "immutability-helper";
import { setSuccessMessage, setErrorMessage } from "./common";
import { AppThunk } from "../redux/store";
import { YardiDatabase } from "../typeDefs/yardidata";
import { parseSqlDateTimeNullable } from "../components/common/utils/utils";

export const getYardiDbs = (): AppThunk<void> => (dispatch) => {
    axios
        .get<any[]>("api/yardi-data/database")
        .then((res) => {
            const yardiDbs = res.data.map(
                (db): YardiDatabase => ({
                    Id: db.Id,
                    LastSftpCredentialUpdate: parseSqlDateTimeNullable(
                        db.LastSftpCredentialUpdate
                    ),
                    FullBackupPath: db.FullBackupPath,
                    TranLogBackupPath: db.TranLogBackupPath,
                    YardiTimeZoneName: db.YardiTimeZoneName,
                    VoyagerUrl: db.VoyagerUrl,
                    ElevateUrl: db.ElevateUrl,
                    EnableMerge: db.EnableMerge,
                })
            );
            dispatch(setYardiDbs(yardiDbs));
            dispatch(setSelectedDb(yardiDbs[0]));
        })
        .catch((err) => {
            console.error(err);
            dispatch(setErrorMessage("Could not get database list"));
        });
};

export const getTimeZones = (): AppThunk<void> => (dispatch) => {
    axios
        .get("api/yardi-data/timezones")
        .then((res) => {
            dispatch(setTimeZones(res.data));
        })
        .catch((err) => console.error(err));
};

export const getYardiDb =
    (id: string): AppThunk<void> =>
    (dispatch, getState) => {
        axios
            .get(`api/yardi-data/database/${id}`)
            .then((res) => {
                const {
                    yardidata: { yardiDbs },
                } = getState();
                const index = yardiDbs.findIndex((db) => db.Id === res.data.Id);
                const newDbs = update(yardiDbs, {
                    [index]: { $set: res.data },
                });

                dispatch(setYardiDbs(newDbs));
                dispatch(setSelectedDb(res.data[0]));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setErrorMessage("Could not get database"));
            });
    };

export const checkIfYardiDbExists = (): AppThunk<void> => (dispatch) => {
    dispatch(setCredsLoading(true));
    axios
        .get("api/yardi-data/yardi-data")
        .then((res) => {
            dispatch(setNeedsCreds(!Boolean(res.data)));
            dispatch(setCredsLoading(false));
        })
        .catch((err) => {
            console.error(err);
            dispatch(setCredsLoading(false));
            dispatch(setErrorMessage("Could not check credentials"));
        });
};

export const checkYardiDbStatus = (): AppThunk<void> => (dispatch) => {
    dispatch(setCredsLoading(true));
    axios
        .get("api/yardi-data/needs-creds")
        .then((res) => {
            dispatch(setNeedsCreds(Boolean(res.data)));
            dispatch(setCredsLoading(false));
        })
        .catch((err) => {
            console.error(err);
            dispatch(setCredsLoading(false));
            dispatch(setErrorMessage("Could not check credentials"));
        });
};

export const getIsLockedDown = (): AppThunk<void> => (dispatch) => {
    axios
        .get("api/yardi-data/is-locked-down")
        .then((res) => {
            dispatch(setLockedDown(Boolean(res.data)));
        })
        .catch((err) => {
            console.error(err);
            dispatch(setErrorMessage("Could not check locked status"));
        });
};

export const updateYardiDb =
    (db: YardiDatabase): AppThunk<void> =>
    (dispatch) => {
        axios
            .put("api/yardi-data/update", db)
            .then((res) => {
                dispatch(setSuccessMessage("Database updated!"));
                dispatch(getYardiDbs());
            })
            .catch((err) => {
                console.error(err);
                dispatch(setErrorMessage("Failed to update database"));
            });
    };

export const getServerName = (): AppThunk<void> => (dispatch) => {
    dispatch(setServerLoading(true));
    axios
        .get("api/yardi-data/server")
        .then((res) => {
            dispatch(setServerName(res.data));
            dispatch(setServerLoading(false));
        })
        .catch((err) => {
            console.error(err);
            dispatch(setErrorMessage("Failed to get server name"));
            dispatch(setServerLoading(false));
        });
};
